<template>
    <div>
        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="1000px"
            class="pay_class"
            >
                <div style="padding: 0  0 20px 20px;font-size: 18px;">
                    <p>姓名：{{ userInfo.studentName }}</p>
                    <p>待缴费金额：<span style="color:red">￥ {{ toBePaid }}</span></p>
                    <template v-if="!$strExistHostnameOnce(['hsnc'])">
                        <p>身份证号：{{ userInfo.studentIdCard || "-" }}</p>
                    </template>
                    <template v-else>
                        <p>学号：{{ userInfo.studentNo || "-" }}</p>
                    </template>

                     <!-- <div style="margin-top: 20px; margin-bottom: 20px;">
                        <el-table :data="mandatoryPayList" border style="width: 100%">
                            <el-table-column prop="payName" label="缴费项目"></el-table-column>
                            <el-table-column prop="payAmount" label="应缴金额(元)"></el-table-column>
                        </el-table>
                    </div>  -->

                    <el-button type="primary" @click="payDialogClick">去支付</el-button>
                    <el-row style="color: red; margin-top: 10px;">
                        提示：为解决继续教育学员工学矛盾，可选线上教学。线上课件、作业、考试费自愿缴纳，入学至毕业仅需缴纳一次。如有疑问，请联系负责老师。
                    </el-row>
                </div>

                <div slot="footer" v-if="openNoPay2StudyWithoutScore == 1" class="dialog-footer" align="center">
                    <el-button @click="dialogVisible = false">关 闭</el-button>
                </div>
        </el-dialog>

        <el-dialog :title="pay_dialog.title" :visible.sync="pay_dialog.visible" class="payDialog" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div style="font-size: 18px;">
                <el-row>
                    <el-col>
                        <span class="spanTitle">支付金额</span>
                        <span class="money">￥{{ toBePaid }}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <span class="spanTitle">支付订单号</span>
                        <span>{{ payId }}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <div class="typeBox">
                            <span class="spanTitle">支付方式</span>
                            <img src="../assets/wechat.png" alt="" :class="pay_dialog.payType == 'wechat' ? 'selected' : ''"
                                @click="changePayType('wechat')">
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="pay_dialog.visible = false">返 回</el-button>
                <el-button type="primary" @click="goPay">立即支付</el-button>
            </div>
        </el-dialog>

        <el-dialog width="600px" :visible.sync="pay_dialog.inner_dialog.visible" append-to-body @close="closePay_dialog" class="payInnerDialog" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
            <div slot="title" class="dialog-title" style="display: flex;align-items: center">
                <img :src="pay_dialog.payType === 'wechat' ? require('../assets/wechat.png') : require('../assets/alipay.png')"
                    alt="">
                <span style="margin-left: 1em">{{ pay_dialog.inner_dialog.title }}</span>
                <span style="flex:1"></span>
                <el-button type="text" @click="closeInnerDialog">返回</el-button>
            </div>
            <div v-if="pay_dialog.payType === 'wechat'" id="mandatory_qrcode" ref="qrcode"
                style="border: none;height: 147px;line-height: 147px;width: 147px;margin: 0 auto;text-align: center;">
                <i class="el-icon-loading" style="font-size: 30px;"></i></div>
            <iframe v-else :src="pay_dialog.inner_dialog.imgSrc" width="200px" height="210px"
                style="border: none;"></iframe>
            <p class="tip" style="color:red;text-align: center;padding-bottom: 20px;">请扫码支付 ￥{{ toBePaid }}</p>
        </el-dialog>
    </div>
</template>
<script>
    import QRCode from 'qrcodejs2';
    import {
        getWeChatPayQRCode,
        getAliPayQRCode,
        createStudentStatusPayId
    } from "../common/services";
    import { get } from "../common/request";
export default {
    name: 'studentMandatoryPay',
    props: {
        mandatoryPayList: {
            type: Array,
            default: () => []
        },
        openNoPay2StudyWithoutScore:{
            type: String,
            default: () => 2
        }
    },
    data() {
        return {
            dialogVisible: true,
            userInfo: {},
            toBePaid:0, //缴费金额
            // 支付
            pay_dialog: {
                visible: false,
                title: "选择支付方式",
                payType: "wechat",
                inner_dialog: {
                    imgSrc: "",
                    visible: false,
                    title: "微信支付",
                }
            },
            payId: "",//支付订单号
            payStatusTimeout: null,
        }
    },
    created() {
        this.getPayAmount();
        const studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag())); //获取学生信息
        this.userInfo = studentInfo || {};
    },
    methods:{
        getPayAmount() { //获取在籍生缴费金额 直接从pay_config查type=2
            const prefix = window.configs.API_ROOT;
            get(`${prefix}/api/payConfig/getByType`, { type: 2 }).then((ret) => {
                if(ret.code == 0 && ret.data != null && ret.data.feeAmount > 0){
                    this.toBePaid = ret.data.feeAmount;
                } else if (this.mandatoryPayList && this.mandatoryPayList.length > 0) {
                    let total = 0;
                    this.mandatoryPayList.forEach(item => {
                        total += Number(item.payAmount || item.money || 0);
                    });
                    this.toBePaid = total;
                }
            }).catch(() => {

            });
        },
        async payDialogClick(){ //去支付
            //在籍学生先创建订单，获取订单outTradeNo，等拿到payId再弹窗
            await this.getCreatStudentStatusOrder();
            this.pay_dialog.visible = true;
        },
        changePayType(type = 'wechat') {
            this.pay_dialog.payType = type;
            this.pay_dialog.inner_dialog.imgSrc = "";
        },
        getWeChatQrcode(text) {
            this.$refs.qrcode.innerHTML = "";
            return new QRCode('mandatory_qrcode', {
                width: 147, // 设置宽度，单位像素
                height: 147, // 设置高度，单位像素
                text,   // 设置二维码内容或跳转地址
            })

        },
        async goPay() {
            const originDialog = this.pay_dialog;
            const originInnerDialog = originDialog.inner_dialog;
            const payType = originDialog.payType;
            this.pay_dialog.inner_dialog = {
                ...originInnerDialog,
                visible: true,
                title: payType === 'wechat' ? '微信支付' : '支付宝支付'
            }
            // 等待DOM渲染完成后再生成二维码，否则第一次ref="qrcode"元素还不存在
            await this.$nextTick();
            const imgPath = await this.getPayQRCode(payType);
            this.pay_dialog.inner_dialog.imgSrc = imgPath;
        },
        async getPayQRCode(type = 'wechat') {
            this.payStatusTimeout = setInterval(() => { //轮训获取支付状态。
                this.getPayStatusTimeout();
            }, 3500);
            if (type == 'wechat') {
                const prefix = window.configs.API_ROOT;
                let obj = {
                    price: this.toBePaid,
                    baseUrl: prefix,
                    payId: this.payId,
                    studentId: this.userInfo.studentId
                }
                const params = JSON.stringify(obj)
                const imgPath = this.getWeChatQrcode(`${prefix}/api/student/wxLogin.do?params=${params}`);
                return "";
            } else {
                const res = await getAliPayQRCode(this.payId);
                return res.data;
            }
        },
        getCreatStudentStatusOrder() { //在籍学生创建订单，获取订单outTradeNo
            return createStudentStatusPayId().then((ret) => {
                if (ret.code == 0) {
                    this.payId = ret.data;
                }
            }).catch(() => {

            });
        },
        getPayStatusTimeout() { //用于轮训查询缴费状态
            this.$store.dispatch("user/getStudentStatusPayInfo").then((ret) => {
                if (ret.code == 0) {
                    if (ret.data && ret.data.payStatus == 1 && this.payStatusTimeout != null) { //1已缴费  2未交费
                        clearInterval(this.payStatusTimeout);
                        this.$message({
                            message: ret.data.payMsg || '缴费成功',
                            type: 'success',
                            duration:2000,
                            onClose: () => {
                                this.dialogVisible = false;
                                this.pay_dialog.inner_dialog.visible = false;
                                this.pay_dialog.visible = false;
                                window.location.reload(); // 刷新页面消除拦截
                            }
                        });

                    }
                }
            }).catch(() => {

            });
        },
        closeInnerDialog() {
            this.pay_dialog.inner_dialog.visible = false;
            this.closePay_dialog();
        },
        closePay_dialog(){
            if(this.payStatusTimeout != null){
                clearInterval(this.payStatusTimeout);
            }
        }
    }
};
</script>
<style lang="less">
    .pay_class{
        img{
            max-width: 100%;
            height: auto;
            cursor: pointer;
        }
        h2{
            p{
                margin-top: 0;
            }
        }
    }
    .payDialog {
        .spanTitle {
            display: inline-block;
            width: 100px;
            text-align: right;
        }

        .el-col {
            line-height: 2em;

            span {
                &.money {
                    color: red;
                }

                &:nth-child(2) {
                    margin-left: 2em;
                }
            }

            .typeBox {
                span {
                    line-height: 50px;
                    vertical-align: top;
                    display: inline-block;
                }

                img {
                    margin-left: 2em;
                    padding: 10px;
                    border: 1px solid transparent;

                    &.selected {
                        border-color: lightgrey;
                        box-shadow: 0 0 1px grey inset;
                        border-radius: 10px;
                    }

                }
            }

        }

        p.tip {
            margin-bottom: 3em;
        }

        .payInnerDialog {}
    }
</style>



// WEBPACK FOOTER //
// src/components/studentMandatoryPay.vue